import React from 'react'
import { BASE_URL } from '../../utils/apiPaths'

const UserCard = ({userInfo}) => {
  return (
    <div className="user-card p-2">
      <div className="flex items-center gap-5">
        <div className="flex items-center gap-3">
          <img src={`${BASE_URL}${userInfo?.profileImageUrl}`} alt={`avatar`} className="w-12 h-12 rounded-full border-white "/>
        </div>
        <div>
          <p className="text-sm font-medium">{userInfo?.name}</p>
          <p className="text-xs text-gray-500">{userInfo?.email}</p>
        </div>
      </div>
      <div className="flex items-end gap-3 mt-5">
        <StatCard label="enattente" count={userInfo?.pendingTasks || 0 } status="enattente" />
        <StatCard label="encours" count={userInfo?.inProgressTasks || 0 } status="encours" />
        <StatCard label="termine" count={userInfo?.completedTasks || 0 } status="termine" />
        <StatCard label="enretard" count={userInfo?.dueDateTasks || 0 } status="enretard" />
      </div>
    </div>
  )
}

export default UserCard

const StatCard = ({label,count,status})=>{
const getStatusColor = () => {
    switch (status) {
      case "encours":
        return "text-cyan-500 bg-gray-50";
      case "termine":
        return "text-indigo-500 bg-gray-50";
        case "enretard":
        return " text-red-500  bg-gray-50";
      default:
        return " text-violet-500  bg-gray-50";
    }
  };
  return(
   <div className={`flex-1 text-[10px] font-medium ${getStatusColor()} px-4 py-0.5 rounded`}>
    <span className="text-[12px] font-semibold">{count}<br/></span>{label}
   </div>
  )

}